import { defineNuxtPlugin } from '#app/nuxt'
import { LazyActionPanel, LazyAnimatedModal, LazyCommandPalette, LazyCommentsComponent, LazyComparisonSlider, LazyDrawerPanel, LazyFilter, LazyFormFieldLabel, LazyFormImagesSection, LazyIssueForm, LazyIssueThumbnail, LazyListComponent, LazyLoadSpinner, LazyLoginForm, LazyMapComponent, LazyMenuDropDown, LazyModalComponent, LazyNfsAlert, LazyNfsButton, LazyNfsCard, LazyNfsEmptyState, LazyNfsFileUploader, LazyNfsHeader, LazyNfsIcon, LazyNfsInput, LazyNfsProgressBar, LazyNfsSelect, LazyNfsSidebar, LazyNfsTable, LazyOfflineAlert, LazyRadialProgress, LazyScheduler, LazySectionHeader, LazyTimeline, LazyUserWidget, LazySvgoBell, LazySvgoCalendar, LazySvgoCamera, LazySvgoCategory, LazySvgoCheck, LazySvgoComplexity, LazySvgoFileUpload, LazySvgoHambergerMenu, LazySvgoHidePassword, LazySvgoHome, LazySvgoIconCross, LazySvgoIconExpandDown, LazySvgoIconExpandUp, LazySvgoIconPlus, LazySvgoKey, LazySvgoList, LazySvgoLogo, LazySvgoMail, LazySvgoPassword, LazySvgoPhoto, LazySvgoPlusSmall, LazySvgoRoadPin, LazySvgoSetting, LazySvgoShieldCheck, LazySvgoShowPassword, LazySvgoTag, LazySvgoTrash, LazySvgoUser, LazySvgoUsers } from '#components'
const lazyGlobalComponents = [
  ["ActionPanel", LazyActionPanel],
["AnimatedModal", LazyAnimatedModal],
["CommandPalette", LazyCommandPalette],
["CommentsComponent", LazyCommentsComponent],
["ComparisonSlider", LazyComparisonSlider],
["DrawerPanel", LazyDrawerPanel],
["Filter", LazyFilter],
["FormFieldLabel", LazyFormFieldLabel],
["FormImagesSection", LazyFormImagesSection],
["IssueForm", LazyIssueForm],
["IssueThumbnail", LazyIssueThumbnail],
["ListComponent", LazyListComponent],
["LoadSpinner", LazyLoadSpinner],
["LoginForm", LazyLoginForm],
["MapComponent", LazyMapComponent],
["MenuDropDown", LazyMenuDropDown],
["ModalComponent", LazyModalComponent],
["NfsAlert", LazyNfsAlert],
["NfsButton", LazyNfsButton],
["NfsCard", LazyNfsCard],
["NfsEmptyState", LazyNfsEmptyState],
["NfsFileUploader", LazyNfsFileUploader],
["NfsHeader", LazyNfsHeader],
["NfsIcon", LazyNfsIcon],
["NfsInput", LazyNfsInput],
["NfsProgressBar", LazyNfsProgressBar],
["NfsSelect", LazyNfsSelect],
["NfsSidebar", LazyNfsSidebar],
["NfsTable", LazyNfsTable],
["OfflineAlert", LazyOfflineAlert],
["RadialProgress", LazyRadialProgress],
["Scheduler", LazyScheduler],
["SectionHeader", LazySectionHeader],
["Timeline", LazyTimeline],
["UserWidget", LazyUserWidget],
["SvgoBell", LazySvgoBell],
["SvgoCalendar", LazySvgoCalendar],
["SvgoCamera", LazySvgoCamera],
["SvgoCategory", LazySvgoCategory],
["SvgoCheck", LazySvgoCheck],
["SvgoComplexity", LazySvgoComplexity],
["SvgoFileUpload", LazySvgoFileUpload],
["SvgoHambergerMenu", LazySvgoHambergerMenu],
["SvgoHidePassword", LazySvgoHidePassword],
["SvgoHome", LazySvgoHome],
["SvgoIconCross", LazySvgoIconCross],
["SvgoIconExpandDown", LazySvgoIconExpandDown],
["SvgoIconExpandUp", LazySvgoIconExpandUp],
["SvgoIconPlus", LazySvgoIconPlus],
["SvgoKey", LazySvgoKey],
["SvgoList", LazySvgoList],
["SvgoLogo", LazySvgoLogo],
["SvgoMail", LazySvgoMail],
["SvgoPassword", LazySvgoPassword],
["SvgoPhoto", LazySvgoPhoto],
["SvgoPlusSmall", LazySvgoPlusSmall],
["SvgoRoadPin", LazySvgoRoadPin],
["SvgoSetting", LazySvgoSetting],
["SvgoShieldCheck", LazySvgoShieldCheck],
["SvgoShowPassword", LazySvgoShowPassword],
["SvgoTag", LazySvgoTag],
["SvgoTrash", LazySvgoTrash],
["SvgoUser", LazySvgoUser],
["SvgoUsers", LazySvgoUsers],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
